import { HttpClient, HttpContext, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environment/environment';
import { catchError, map, of } from 'rxjs';
import { SUPPRESS_AUTH_ERROR_REDIRECT } from '../../interceptors/token-interceptor';

export const allowedChevronGroupGuard: CanActivateFn = () => {
  const http = inject(HttpClient);
  const router = inject(Router);
  const context = new HttpContext().set(SUPPRESS_AUTH_ERROR_REDIRECT, true);

  return http.get<void>(`${environment.appApiURL}access`, { context }).pipe(
    map(() => true),
    catchError((error: HttpErrorResponse) => {
      if (error.status === HttpStatusCode.Unauthorized) {
        return of(router.parseUrl('/401'));
      }

      if (error.status === HttpStatusCode.Forbidden) {
        return of(router.parseUrl('/403'));
      }

      return of(router.parseUrl('/500'));
    })
  );
};